export const dubaiPackage = {
  id: "dubai-6d5n",
  title: "Dubai Tour",
  country: "United Arab Emirates",
  days: 6,
  nights: 5,
  price: "₹85,000 per person",
  thumbnail: "https://images.pexels.com/photos/27206539/pexels-photo-27206539.jpeg",
  description:
    "Discover Dubai’s breathtaking skyline, desert safaris, luxury shopping, and cultural gems. This 6D/5N trip is carefully designed for travelers who want the perfect balance of exploration and relaxation. Discover Dubai’s breathtaking skyline, desert safaris, luxury shopping, and cultural gems. This 6D/5N trip is carefully designed for travelers who want the perfect balance of exploration and relaxation. Discover Dubai’s breathtaking skyline, desert safaris, luxury shopping, and cultural gems. This 6D/5N trip is carefully designed for travelers who want the perfect balance of exploration and relaxation.",

  highlights: [
    "City tour with professional guide",
    "Desert Safari with BBQ dinner",
    "Burj Khalifa entry ticket",
    "5-star accommodation with breakfast",
    "Return flights & airport transfers",
  ],

  included: [
    "Round trip airfare",
    "Accommodation in 4/5 star hotels",
    "Daily breakfast",
    "Sightseeing tours with transfers",
    "Travel insurance",
  ],

  itinerary: [
    {
      day: 2,
      title: "Arrival in Dubai",
      description:
        "Welcome to Dubai! Meet our representative at the airport and transfer to your hotel. Evening free for leisure.",
      photo: "https://images.pexels.com/photos/8428013/pexels-photo-8428013.jpeg",
    },
    {
      day: 1,
      title: "Dubai City Tour & Burj Khalifa",
      description:
        "Guided city tour covering Dubai Creek, Jumeirah Mosque, Palm Island, and an evening visit to Burj Khalifa.",
      photo: "https://images.pexels.com/photos/2044434/pexels-photo-2044434.jpeg",
    },
    {
      day: 3,
      title: "Desert Safari Adventure",
      description:
        "Thrilling dune bashing, camel rides, cultural shows, and a delicious BBQ dinner under the stars.",
      photo: "https://images.pexels.com/photos/1008155/pexels-photo-1008155.jpeg",
    },
    {
      day: 4,
      title: "Abu Dhabi Excursion",
      description:
        "Day trip to Abu Dhabi including Sheikh Zayed Grand Mosque and Ferrari World.",
      photo: "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg",
    },
    {
      day: 5,
      title: "Shopping & Leisure",
      description:
        "Explore Dubai Mall, traditional souks, or optional activities like Dubai Marina cruise.",
      photo: "https://images.pexels.com/photos/3787838/pexels-photo-3787838.jpeg",
    },
    {
      day: 6,
      title: "Departure",
      description:
        "Check out from hotel and transfer to airport for your flight back home.",
      photo: "https://images.pexels.com/photos/164595/pexels-photo-164595.jpeg",
    },
  ],

  gallery: [
    "https://images.pexels.com/photos/3787839/pexels-photo-3787839.jpeg",
    "https://images.pexels.com/photos/3787838/pexels-photo-3787838.jpeg",
    "https://images.pexels.com/photos/1619563/pexels-photo-1619563.jpeg",
    "https://images.pexels.com/photos/1110658/pexels-photo-1110658.jpeg",
    "https://images.pexels.com/photos/460672/pexels-photo-460672.jpeg",
    "https://images.pexels.com/photos/162031/dubai-tower-arab-khalifa-162031.jpeg",
    "https://images.pexels.com/photos/325193/pexels-photo-325193.jpeg ",
    "https://images.pexels.com/photos/4612431/pexels-photo-4612431.png",
    "https://images.pexels.com/photos/29555692/pexels-photo-29555692.jpeg",
    "https://images.pexels.com/photos/8428013/pexels-photo-8428013.jpeg",
  ],

  groupDates: [
    { group: "Group 1", start: "2025-10-04", end: "2025-10-09" },
    { group: "Group 2", start: "2025-10-18", end: "2025-10-23" },
    { group: "Group 3", start: "2025-11-02", end: "2025-11-07" },
  ],

  brochure: "https://firebasestorage.googleapis.com/v0/b/paryatakadmin.firebasestorage.app/o/packages%2F1759063174854_beach.png?alt=media&token=8d4670bf-852c-4b9d-88ca-2b0517d67188",

  rating: {
    stars: 4.8,
    reviews: 120
  },
  

  reviews: [
    {
      stars: 5,
      review: "Amazing trip! Everything was well-organized and smooth.",
      name: "Rahul Sharma",
    },
    {
      stars: 4,
      review: "Dubai is beautiful! Wish we had one more day for shopping.",
      name: "Ananya Verma",
    },
    {
      stars: 5,
      review: "Best travel experience ever. Highly recommend this package.",
      name: "Arjun Mehta",
    },
  ],
};
